import axios, { AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios'
import { getToken } from '@/utils/token'
import { message } from 'ant-design-vue'
// import { loginOut } from '@/apis/user'
import { removeToken } from '@/utils/token'
import router from '@/router'
import { useUserInfoStore } from '@/stores/user-info'
message.config({
    maxCount: 1
})

interface Func {
    (): void
}
type Pending = {
    u: string | undefined
    f: Func
    time: number
    notCancel?: boolean
}

const pendings = [] as Pending[] //用于存储每个请求的取消函数和标识
const cancelToken = axios.CancelToken

class HttpRequest {
    baseURL: string
    constructor(baseURL: string) {
        this.baseURL = baseURL
    }
    getBaseConfig(): unknown {
        const config = {
            baseURL: this.baseURL,
            headers: {
                token: getToken(),
                device: ''
            },
            timeout: 10 * 60 * 1000
        }
        return config
    }
    interceptors(instance: AxiosInstance): void {
        // 请求拦截
        instance.interceptors.request.use(
            (config: any) => {
                config.cancelToken = new cancelToken((c) => {
                    pendings.push({
                        u: config.url,
                        f: c,
                        time: +new Date(),
                        notCancel: config.notCancel
                    })
                })
                return config
            },
            (error) => {
                return Promise.reject(error)
            }
        )
        // 响应拦截
        instance.interceptors.response.use(
            (response) => {
                const { data, config } = response
                const errorCode = [10000031, 10000006, 10000007, 10000028, 10000026]
                // 未登录||登录过期||权益过期||用户冻结

                if (errorCode.includes(data.code)) {
                    if (!location.href.endsWith('/login')) {
                        // 登录页不展示用户未登录了
                        message.error(data.message)
                    }
                    removeToken()
                    const userStore = useUserInfoStore()
                    userStore.clearUserInfo()
                    return Promise.reject(response)
                } else if (data.code !== 0 && data.code !== 200) {
                    message.error(data.message)
                    return Promise.reject(response)
                }
                return response.data
            },
            (error) => {
                //标记该错误返回是重复操作导致取消请求
                if (error.__proto__.__CANCEL__) {
                    return Promise.reject({ stack: '(cancel)' })
                }
                return Promise.reject(error)
            }
        )
    }
    request(options: any): AxiosPromise<any> {
        const instance = axios.create()
        // 移除空字段
        if (options.data) {
            for (const key in options.data) {
                if (options.data[key] === '') delete options.data[key]
            }
        }
        if (options.params) {
            for (const key in options.params) {
                if (options.params[key] === '') delete options.params[key]
            }
        }
        options = Object.assign(this.getBaseConfig(), options)
        this.interceptors(instance)
        return instance(options)
    }
}

export default HttpRequest
